import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asbmccontact',
  templateUrl: './asbmccontact.component.html',
  styleUrls: ['./asbmccontact.component.scss']
})
export class AsbmccontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
